import React from 'react';
import Navbar from '..';

const BottomNavbar: React.FC = (): JSX.Element => {
    return <Navbar mobile />;
};

export default BottomNavbar;
